import { Component, ComponentChild } from "preact";
import * as d3 from 'd3';

import TaxonLink from "@/ui/taxon_link";
import Table from "@/ui/table";
import * as db from "@/db";

class SpeciesTable extends Component<
  { query: () => Promise<db.SpeciesTable>, taxonomy: db.TaxonomyDB },
  { table: db.SpeciesTable }
> {
  state: { table: db.SpeciesTable } = { table: {
    years: { min: 0, max: 0 }, species: [],
  } };

  constructor(props: SpeciesTable['props']) {
    super(props)
    this.props.query().then(table => {
      this.setState({ table });
    });
  }

  render() {
    const { taxonomy } = this.props;
    const { table } = this.state;

    if (0 === table.species.length) {
      return;
    }

    const years = d3.range(table.years.min, table.years.max+1);
    const yearSums = Object.fromEntries(years.map(y => [y, { firsts: 0, total: 0 }]));
    let total = 0;

    // TODO: Inflate these better so it's easier to get the taxon and years
    const rows: ComponentChild[][] = table.species.map((r, i) => {
      const species = taxonomy.code(r.code);
      let first = true;

      return [
        i + 1,
        <TaxonLink taxon={ species }/>,
        ...years.map(y => {
          if (r.years.has(y)) {
            yearSums[y].total++;
            if (first) {
              yearSums[y].firsts++;
              total++;
              first = false;
              return '✔'; // TODO: Bold instead of heavy-check?
            }
            return '✓';
          }
          return '';
        }),
        r.years.size,
      ]
    });

    // TODO: Fix the class names here...
    return <table class='day-counts data-table'>
      <Table.Header rows={ [[ '#', 'Species', ...years, 'All' ]] }/>
      <Table.Body rows={ rows } />
      <Table.Footer rows={[
        [ '', 'Firsts', ...years.map(y => yearSums[y].firsts), total ],
        [ '', 'Totals', ...years.map(y => yearSums[y].total), '-' ],
      ]}/>
    </table>;
  }
}

export default SpeciesTable;
